import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTypeStrikethrough01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.293 2.293a1 1 0 0 1 1.414 0l18 18a1 1 0 0 1-1.414 1.414L13 14.414V19h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-6.586l-6-6V7a1 1 0 0 1-2 0V6c0-.463.105-.902.293-1.293l-1-1a1 1 0 0 1 0-1.414Zm15.733 2.724A16.908 16.908 0 0 0 17 5h-4v1.5a1 1 0 1 1-2 0V5H9.5a1 1 0 0 1 0-2h7.532c.439 0 .817 0 1.13.021.33.023.66.072.986.207a3 3 0 0 1 1.624 1.624c.135.326.184.656.207.986.021.313.021.691.021 1.13V7a1 1 0 1 1-2 0c0-.48 0-.79-.017-1.026-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgTypeStrikethrough01.displayName = 'TypeStrikethrough01';
export default SvgTypeStrikethrough01;
